import { getLevels } from "store/game/thunkActions";
import logger from "../../utils/logger";
import { fetchRequest } from "../../utils/restApiCleintAxios";
import { AppThunk } from "../index";
import {
  setSimpleField,
  setSuccesDataPayment,
  setTriggerAlert,
  setUser,
  updateSettings
} from "./slice";
import xml2js from "xml2js";
import { localStorageKeys } from "config/localStorageKeys";
import { ProgramItems } from "types/landing";

export const signIn =
  (data: any): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      sessionStorage.setItem("is2x", "");
      const res = await fetchRequest("api/user/Login", {
        method: "post",
        data: {
          userName: data?.email,
          password: data?.password
        }
      });

      const resUser: any = await dispatch(getUserInfo(res?.data?.loginInfo?.ctoken));

      const fullUserData = {
        ...res.data?.loginInfo,
        ...resUser.userDetails?.user,
        key: resUser.key
      };

      dispatch(setUser(fullUserData));
      dispatch(setSimpleField({ type: "isAuth", value: true }));

      localStorage.setItem(localStorageKeys.userInfo, JSON.stringify(fullUserData));

      if (res.data?.status === "ERROR") {
        return Promise.reject(res.data);
      }
      return res;
    } catch (err) {
      console.error(err);
      return Promise.reject(err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const logout = (): AppThunk => async (dispatch) => {
  try {
    localStorage.removeItem(localStorageKeys.userInfo);
    dispatch(setSimpleField({ type: "isAuth", value: false }));
  } catch (err) {
    console.error("Logout error:", err);
  }
};

export const signUp =
  (data: any): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(
        setSimpleField({
          type: "isLoading",
          value: true
        })
      );

      const url = new URL(location.href);
      const refLink = url.searchParams.get("refLink");

      const res = await fetchRequest("api/user/Signup", {
        method: "post",
        data: {
          firstname: data?.firstName,
          lastname: data?.lastName,
          phoneNumber: data?.phone,
          email: data?.email,
          bridgelevel: "10",
          subscriber: data?.subscriber,
          password: data?.password,
          refLink
        }
      });

      if (res.data?.message === "הנכם רשומים במערכת, לא ניתן לבחור מסלול חינם.") {
        // dispatch(
        //   setTriggerAlert({
        //     show: true,
        //     title: res.data?.message
        //   })
        // );
      }
      if (res.data?.status === "ERROR") {
        return Promise.reject(res.data);
      }
      return res;
    } catch (err) {
      return Promise.reject(err);
    } finally {
      dispatch(
        setSimpleField({
          type: "isLoading",
          value: false
        })
      );
    }
  };

export const getExercise =
  (id: number, courseId?: number): AppThunk =>
  async (dispatch, getState) => {
    const token = getState().user.client.ctoken;
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/Exercise/GetExerciseById", {
        method: "post",
        data: {
          Id_Exercise: id,
          ctoken: token,
          courseId
        }
      });

      let xmlRes: any = {};
      xml2js.parseString(res.data?.Results[0]?.Data?.XmlData, { trim: true }, (err, result) => {
        if (result && !err) {
          xmlRes = result;
        }
      });
      return { data: res, xml: xmlRes };
    } catch (err) {
      logger.error("err", err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const getExerciseHandPlay =
  (id: number): AppThunk =>
  async (dispatch, getState) => {
    const token = getState().user.client.ctoken;
    const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
    let userInfoParse: any = {};
    if (userInfoStr) {
      userInfoParse = JSON.parse(userInfoStr);
    }
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/PHF/GetExerciseById", {
        method: "post",
        data: {
          IdExercise: id,
          ctoken: token || userInfoParse?.ctoken
        }
      });
      return res.data;
    } catch (err) {
      logger.error("err", err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const getExerciseDeffense =
  (id?: number, courseId?: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const token = getState().user.client.ctoken;
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/PHDefense/GetExerciseById", {
        method: "post",
        data: {
          IdExercise: id || getState().game.gameInfoDeffensePlay?.globalGameId,
          courseId: courseId || getState().game.gameInfoDeffensePlay.courseId,
          Language: "he",
          ctoken: token
        }
      });

      return { data: res };
    } catch (err) {
      logger.error("err", err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const getExerciseDefLead =
  (id: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const { courseId } = getState().game.gameInfoDefLeadPlay;
      const token = getState().user.client.ctoken;
      const res = await fetchRequest("api/DefLead/GetExerciseById", {
        method: "post",
        data: {
          ExerciseId: id,
          CourseId: courseId,
          ctoken: token
        }
      });

      return { data: res };
    } catch (err) {
      logger.error("err", err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const getInfoTricks = (): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(setSimpleField({ type: "isLoading", value: true }));
    const token = getState().game.gameInfoTricksPlay.token;
    const res = await fetchRequest("api/PHMiniHandler/GameInfo", {
      method: "post",
      data: {
        userToken: token
      }
    });

    return { data: res };
  } catch (err) {
    logger.error("err", err);
  } finally {
    dispatch(setSimpleField({ type: "isLoading", value: false }));
  }
};

export const getExerciseTricks =
  (id: number, courseId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/PHMini/GetExerciseById", {
        method: "post",
        data: {
          IdExercise: id,
          CourseId: courseId
        }
      });

      return { data: res };
    } catch (err) {
      logger.error("err", err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const getExerciseInteractiveBidding =
  (id: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const { ctoken } = getState().user.client;
      const res = await fetchRequest("api/Bid/GetExerciseById", {
        method: "post",
        data: {
          Id_Bid: id,
          ctoken
        }
      });

      let xmlRes: any = {};

      xml2js.parseString(res.data?.Results[0]?.Data?.XmlData, { trim: true }, (err, result) => {
        if (result && !err) {
          xmlRes = result;
        }
      });
      return { data: res, xml: xmlRes };
    } catch (err) {
      logger.error("err", err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const getExerciseByCource =
  (id: number, level?: string): AppThunk =>
  async () => {
    try {
      const res = await fetchRequest("api/Exercise/GetExercisesByCourseId", {
        method: "post",
        data: {
          CourseId: id,
          Levels: level
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getExerciseByCourceMixBasicBidding = (): AppThunk => async () => {
  try {
    const getIdsStr = localStorage.getItem(localStorageKeys.mixCoursesListID);

    if (getIdsStr) {
      const getIds = JSON.parse(getIdsStr);

      let strCourses = "";
      getIds.forEach((val, index) => {
        strCourses += `${val?.Id}${index !== getIds.length - 1 ? ";" : ""}`;
      });

      const res = await fetchRequest("api/Exercise/GetExercisesMixCourses", {
        method: "post",
        data: {
          MixCourses: strCourses
        }
      });
      return res.data;
    }
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getExerciseByCourceMixInteractiveBidding = (): AppThunk => async () => {
  try {
    const getIdsStr = localStorage.getItem(localStorageKeys.mixCoursesListID);

    if (getIdsStr) {
      const getIds = JSON.parse(getIdsStr);

      let strCourses = "";
      getIds.forEach((val, index) => {
        strCourses += `${val?.Id}${index !== getIds.length - 1 ? ";" : ""}`;
      });

      const res = await fetchRequest("api/Bid/GetBidsMixCourses", {
        method: "post",
        data: {
          MixCourses: strCourses
        }
      });
      return res.data;
    }
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getExerciseByCourceDeffense =
  (id: number): AppThunk =>
  async () => {
    try {
      const res = await fetchRequest("api/PHDefense/GetExercisesByCourse", {
        method: "post",
        data: {
          courseId: id
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getExerciseByCourceDefLead =
  (id: number): AppThunk =>
  async () => {
    try {
      const res = await fetchRequest("api/DefLead/GetExercisesByCourse", {
        method: "post",
        data: {
          CourseId: id
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getExerciseByCourceInteractiveBid =
  (id: number, level?: string): AppThunk =>
  async () => {
    try {
      const res = await fetchRequest("api/Bid/GetBidsByCourseId", {
        method: "post",
        data: {
          CourseId: id,
          Levels: level
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getExerciseByCourceHandPlay =
  (id: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/PHF/GetExercisesByCourse", {
        method: "post",
        data: {
          courseId: id
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const getExerciseByCourceDeffensePlay =
  (id: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/PHDefense/GetExercisesByCourse", {
        method: "post",
        data: {
          courseId: id
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
    }
  };

export const getExerciseByCourceTrickPlay =
  (id: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/PHMini/GetExercisesByCourse", {
        method: "post",
        data: {
          CourseId: id
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
    }
  };

export const getExerciseByCourceMiniBridge =
  (id: number, level?: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/Minibridge/GetExercisesByCourse", {
        method: "post",
        data: {
          courseId: id,
          ...(level && { Levels: level })
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const getExerciseMiniBridge =
  (id: number, courseId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/Minibridge/GetExerciseById", {
        method: "post",
        data: {
          IdExercise: id,
          CourseId: courseId,
          Language: "he"
        }
      });

      return { data: res };
    } catch (err) {
      logger.error("err", err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const getInfoMiniBridgeUser = (): AppThunk => async (dispatch, getState) => {
  try {
    const token = getState().game.gameInfoMiniBridge.token;
    const res = await fetchRequest("api/MinibridgeHandler/GameInfo", {
      method: "post",
      data: {
        userToken: token
      }
    });

    return { data: res };
  } catch (err) {
    logger.error("err", err);
  }
};

export const getExerciseByCourceDeffLeadPlay =
  (id: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setSimpleField({ type: "isLoading", value: true }));
      const res = await fetchRequest("api/DefLead/GetExercisesByCourse", {
        method: "post",
        data: {
          CourseId: id
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    } finally {
      dispatch(setSimpleField({ type: "isLoading", value: false }));
    }
  };

export const forgotPassword =
  (email: string): AppThunk =>
  async (dispatch) => {
    try {
      const res = await fetchRequest("api/user/ForgotPass", {
        method: "post",
        data: {
          userName: email
        }
      });
      if (res.data?.status === "ERROR") {
        return Promise.reject(res.data);
      }
      return res;
    } catch {
      dispatch(
        setTriggerAlert({
          show: true,
          title: "משהו השתבש"
        })
      );
    }
  };

export const getVideoByCourseId =
  (CourseId: number): AppThunk =>
  async (dispatch) => {
    try {
      const res = await fetchRequest("api/Video/GetVideosByCourseId", {
        method: "post",
        data: {
          CourseId
        }
      });
      return res.data;
    } catch {
      dispatch(
        setTriggerAlert({
          show: true,
          title: "משהו השתבש"
        })
      );
    }
  };

export const getVideosForCustomer =
  (courseId: number): AppThunk =>
  async (dispatch, getState) => {
    const ctoken = getState().user.client.ctoken;

    try {
      const res = await fetchRequest("api/Video/GetVideosForCustomer", {
        method: "post",
        data: {
          courseId,
          ctoken
        }
      });
      return res.data;
    } catch (err) {
      dispatch(
        setTriggerAlert({
          show: true,
          title: "משהו השתבש"
        })
      );
      return Promise.reject(err);
    }
  };

export const getAllVideos = (): AppThunk => async (dispatch) => {
  try {
    const res = await fetchRequest("api/Video/GetVideoCourses", {
      method: "get"
    });
    return res.data;
  } catch {
    dispatch(
      setTriggerAlert({
        show: true,
        title: "משהו השתבש"
      })
    );
  }
};

export const getHelp = (): AppThunk => async () => {
  try {
    const res = await fetchRequest("api/content/FAQ", {
      method: "get",
      data: {
        CourseId: 14
      }
    });
    return res.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getUserInfo =
  (tokenArg?: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const token = getState().user.client.ctoken;
      const res = await fetchRequest("api/user/GetUserDetails", {
        method: "post",
        data: {
          ctoken: tokenArg || token
        }
      });

      // Checking on level from backend and writing it in local stroage
      const resLevels: any = await dispatch(getLevels());
      const dataLevels = resLevels?.data?.levels;
      if (dataLevels) {
        let objLocalLevel = {
          hard: false,
          medium: false,
          ease: false
        };
        if (dataLevels?.indexOf("10") !== -1) {
          objLocalLevel = {
            ...objLocalLevel,
            ease: true
          };
        }
        if (dataLevels?.indexOf("20") !== -1) {
          objLocalLevel = {
            ...objLocalLevel,
            medium: true
          };
        }
        if (dataLevels?.indexOf("30") !== -1) {
          objLocalLevel = {
            ...objLocalLevel,
            hard: true
          };
        }
        localStorage.setItem("levels", JSON.stringify(objLocalLevel));
      }
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const changePassword =
  (currentPassword: string, newPassword: string, confirmPassword: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { ctoken, key } = getState().user.client;
      const res = await fetchRequest("api/user/ChangePassword", {
        method: "post",
        data: {
          ctoken,
          key,
          currentPassword,
          newPassword,
          confirmPassword
        }
      });
      return res.data;
    } catch (err: any) {
      return Promise.reject(err);
    }
  };

export const changeUser =
  (phone: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { ctoken, key, phoneNumber } = getState().user.client;

      let dataChange = {};
      if (phone !== phoneNumber) {
        dataChange = {
          PhoneNumber: phone
        };
      }
      if (Object.keys(dataChange).length > 0) {
        const res = await fetchRequest("api/user/UpdateUserDetails", {
          method: "post",
          data: {
            ctoken,
            key,
            ...dataChange
          }
        });
        return res.data;
      }
      return {};
    } catch (err: any) {
      return Promise.reject(err);
    }
  };

export const changeSettings =
  (settings: any): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { ctoken } = getState().user.client;

      const res = await fetchRequest("api/user/SetUserPreferences", {
        method: "post",
        data: {
          ctoken,
          preferences: {
            PlaySound: settings.sound,
            BackgroundColor: settings.fonColor,
            CardsStyle: settings.typeChooseCard === "card" ? 1 : 2,
            BidBoxStyle: settings.typeChooseCardBidding === "card" ? 2 : 1,
            PlayCardDblClick: settings.playCardDblClick
          }
        }
      });
      dispatch(updateSettings(settings));
      localStorage.setItem(localStorageKeys.userPreferences, JSON.stringify(settings));
      return res;
    } catch (err) {
      return Promise.reject(err);
      //
    }
  };

export const getSettings = (): AppThunk => async (dispatch, getState) => {
  try {
    const { ctoken } = getState().user.client;
    const res = await fetchRequest("api/user/GetUserPreferences", {
      method: "post",
      data: {
        ctoken
      }
    });

    const prefData = res.data?.userDetails?.user?.preferences;
    // const shuffleStorage = localStorage.getItem(localStorageKeys.shuffleAction);
    const preferences: any = {
      sound: prefData?.playSound,
      fonColor: prefData?.backgroundColor,
      typeChooseCard: prefData?.cardsStyle === 1 ? "card" : "block",
      typeChooseCardBidding: prefData?.bidBoxStyle === 2 ? "card" : "block",
      // shuffle: shuffleStorage === "true",
      playCardDblClick: prefData?.playCardDblClick
    };

    dispatch(updateSettings(preferences));
    localStorage.setItem(localStorageKeys.userPreferences, JSON.stringify(preferences));
    return res;
  } catch (err) {
    return Promise.reject(err);
    //
  }
};

export const placeOrderFunc =
  (abonementInfoParse: ProgramItems): AppThunk =>
  async (_, getState) => {
    try {
      const { ctoken } = getState().user.client;
      if (abonementInfoParse.id) {
        const res = await fetchRequest("api/User/PlaceOrder", {
          method: "post",
          data: {
            ctoken,
            productId: abonementInfoParse.id
          }
        });
        return res.data;
      }
    } catch (err) {
      return Promise.reject(err);
      //
    }
  };

export const validateOrderFunc =
  (orderId: number, productId: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { client } = getState().user;
      const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
      let userInfoParse: any = {};
      if (userInfoStr) {
        userInfoParse = JSON.parse(userInfoStr);
      }
      console.log("ctoken", client, userInfoParse);
      const res = await fetchRequest("api/Payment/ValidateOrder", {
        method: "post",
        data: {
          ctoken: client?.ctoken || userInfoParse?.ctoken,
          orderId,
          productId
        }
      });
      dispatch(setSuccesDataPayment(res.data));

      return res.data;
    } catch (err) {
      return Promise.reject(err);
      //
    }
  };

export const forgotPasswordSubmit =
  (data: any, vsp: string): AppThunk =>
  async () => {
    try {
      const url = new URL(location.href);

      const resEmailSend = await fetchRequest("api/user/GetUserVsp", {
        method: "post",
        data: {
          vsp: url.search.replaceAll("?vsp=", "")
        }
      });

      const resPassword = await fetchRequest("api/user/ResetPassword", {
        method: "post",
        data: {
          ctoken: resEmailSend.data?.ctoken,
          key: resEmailSend.data?.key,
          newPassword: data?.password,
          confirmPassword: data?.passwordConfirm
        }
      });
      return resPassword.data;
    } catch {
      //
    }
  };

export const getPackages =
  (type: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { client } = getState().user;
      const res = await fetchRequest("api/Bid/GetPackagesWithCourses", {
        method: "post",
        data: {
          ctoken: client?.ctoken,
          type
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getPackageCourses =
  (packageId: number, type: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { client } = getState().user;
      const res = await fetchRequest("api/Bid/GetPackageCourses", {
        method: "post",
        data: {
          ctoken: client?.ctoken,
          type,
          packageId
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getExercisesMixCoursesForPackage =
  (courses: any[]): AppThunk =>
  async () => {
    try {
      let strCourses = "";
      courses.forEach((val, index) => {
        const courseId = val?.id || val?.Id;
        strCourses += `${courseId}${index !== courses.length - 1 ? ";" : ""}`;
      });

      const res = await fetchRequest("api/Exercise/GetExercisesMixCourses", {
        method: "post",
        data: {
          MixCourses: strCourses
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const getBidsMixCoursesForPackage =
  (courses: any[]): AppThunk =>
  async () => {
    try {
      let strCourses = "";
      courses.forEach((val, index) => {
        const courseId = val?.id || val?.Id;
        strCourses += `${courseId}${index !== courses.length - 1 ? ";" : ""}`;
      });

      const res = await fetchRequest("api/Bid/GetBidsMixCourses", {
        method: "post",
        data: {
          MixCourses: strCourses
        }
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };
